<template>
<div>
  <div v-if="isLoading">
    <v-progress-linear
      indeterminate
      color="primary"
      ></v-progress-linear>
  </div>
  <v-container fluid>
    <v-col>
        <v-row>
            <v-col sm="12" md="6" cols="12">
                <search-bar
                    v-model="query.search"
                    v-on:clear="clearSearch"
                    :label="searchLabel"
                    v-on:request-search="onRequestSearch"
                />
            </v-col>
            <v-col sm="12" md="6" cols="12">
                <sort-bar
                    v-model="query.sort"
                    v-bind:items="sortItems"
                    v-on:request-sort="onRequestSort"
                />
            </v-col>

        </v-row>
        <v-row>
        <v-col sm="12" md="6">
            <v-btn
                color="primary"
                @click.stop="showAddAdminDialog=true"
            >
            <v-icon left>
                mdi-plus
            </v-icon>
            Add Admin
            </v-btn>
        </v-col>
        </v-row>
    </v-col>
  </v-container>
  <v-pagination
    v-if="this.pagination != undefined && this.pagination.totalItems > 0"
    v-model="pagination.currentPage"
    v-bind:length="pagination.pageCount"
    circle
    v-on:input = "onRequestPageChange"
  ></v-pagination>
  <div v-if="!isLoading">
    <v-row class="ma-1">
      <v-col
        v-if="admins.length<=0"
      >
        <v-banner
          single-line
          class="text-h6"
        >
          No records
        </v-banner>
      </v-col>
      <v-col
        sm="12" md="6"
        v-for="item in admins"
        :key="item.id"
        class="d-flex child-flex"
      >
          <admin-card @refresh="requestRefresh" :data="item" @delete_success="deleteSuccessCallback" />
      </v-col>
    </v-row>
  </div>
  <add-edit-admin-dialog @refresh="requestRefresh" :visible="showAddAdminDialog" @close="showAddAdminDialog=false"/>
</div>
</template>

<script>
import superAdminApi from '@/api/superAdminApi'
// import snackbar from '@/utils/snackbar'
export default {
  components: {
    'search-bar': () => import('@/components/SearchBar'),
    'sort-bar': () => import('@/components/SortBar'),
    'admin-card': () => import('@/components/AdminCard'),
    'add-edit-admin-dialog': () => import('@/components/AddEditAdminDialog')
  },
  mounted () {
    this.fetchAdminList()
  },

  data: function () {
    return {
      showAddAdminDialog: false,
      dialogAdminData: null,
      query: {
        search: null,
        sort: null,
        page: 1,
        item_per_page: 16
      },
      searchLabel: 'Search for name or address',
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      admins: [],
      isLoading: false,
      sortItems: [
        { text: 'Newest first', value: 'created_at:desc' },
        { text: 'Oldest first', value: 'created_at:asc' }
      ]
    }
  },
  methods: {
    requestRefresh () {
      this.fetchAdminList()
    },
    deleteSuccessCallback () {
      this.fetchAdminList()
    },
    async fetchAdminList () {
      try {
        this.isLoading = true
        const response = await superAdminApi.getAdmins(this.query)
        this.parsePaginationData(response.data)
        this.admins = response.data.data
      } finally {
        this.isLoading = false
      }
    },
    onRequestSort () {
      this.fetchAdminList()
    },
    onRequestSearch () {
      this.fetchAdminList()
    },
    clearSearch () {
      this.query.search = null
      this.fetchAdminList()
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchAdminList()
    }

  }
}
</script>
